/**
 * /user/profile ↔ keyon GetSelfProfile / UpdateSelfProfile.
 * Identity is the session; the body never names accountnumber / unique_ID.
 */
import axios from 'axios';
import { CURR_API } from '@/constants/apis';
import { normalizeSelfProfile, buildSelfProfileWritePayload } from '@/utils/selfProfileForm';

const WEBHOOK = `${CURR_API}/tswebhook.php`;

export async function getSelfProfile({ client } = {}) {
  const http = client || axios;
  const { data } = await http.post(WEBHOOK, {
    AccountUser: { API_Meth: 'GetSelfProfile' },
  });
  if (!data || data.status !== 'Successful' || !data.data) {
    return {
      ok: false,
      status: (data && data.status) || 'Failure',
      message: (data && data.message) || 'Could not load profile',
      profile: null,
    };
  }
  return { ok: true, profile: normalizeSelfProfile(data.data) };
}

export async function updateSelfProfile(profileForm, { client } = {}) {
  const http = client || axios;
  const { data } = await http.post(WEBHOOK, {
    AccountUser: {
      API_Meth: 'UpdateSelfProfile',
      profile: buildSelfProfileWritePayload(profileForm),
    },
  });
  if (!data || data.status !== 'Successful' || !data.data) {
    return {
      ok: false,
      status: (data && data.status) || 'Failure',
      message: (data && data.message) || 'Could not save profile',
      profile: null,
    };
  }
  return { ok: true, profile: normalizeSelfProfile(data.data) };
}
